import {cx} from '@emotion/css';
import React, {ReactElement} from 'react';
import {ArrowIcon} from '@fo/root/designSystem/atoms/Icons';
import {IconSize} from '@fo/root/designSystem/atoms/Icons/IconWrapper';

import styles from './OpenAndCloseArrow.styles';

interface Props {
  isOpen?: boolean;
  className?: string;
}

function OpenAndCloseArrow({isOpen, className}: Props): ReactElement {
  return (
    <ArrowIcon
      size={IconSize.LARGE}
      className={cx(styles.openAndCloseArrow(isOpen), className)}
      testId="ui.icon.OpenAndCloseArrow"
    />
  );
}

export default OpenAndCloseArrow;
